module.exports = __webpack_public_path__ + "static/media/Brow02.f44f05dc.jpeg";